import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppContext } from './Shared/common';
import { Global } from './Shared/global';

@Component({
  template: `
    <div class="redirector-container">
      <div class="spinner">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
      <p>Redirecting...</p>
    </div>
  `,
  styles: [`
    .redirector-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    p {
      color: white;
      margin-top: 20px;
      font-size: 16px;
    }
  `]
})
export class AppRedirectorComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appctx: AppContext
  ) { }

  ngOnInit(): void {
    this.processSearchQuery();
  }

  /**
   * Process redirect URL from query parameters
   */
  processSearchQuery(): void {
    try {
      // Get the redirectto parameter from query string
      let redirectUrl: string = '';

      // Method 1: Get from query params
      this.route.queryParams.subscribe(params => {
        redirectUrl = params['redirectto'] || '';
        
        if (redirectUrl) {
          this.performRedirect(redirectUrl);
        } else {
          // Method 2: Parse from router URL
          const queryString = this.router.url.substring(this.router.url.indexOf('?') + 1);
          if (queryString) {
            const query: string[] = queryString.split('&');
            for (let i = 0; i < query.length; i++) {
              const param = query[i].split('=');
              if (param[0] === 'redirectto') {
                redirectUrl = param[1];
                break;
              }
            }
          }

          if (redirectUrl) {
            this.performRedirect(redirectUrl);
          } else {
            // No redirect URL found, go to dashboard
            console.warn('No redirect URL found, navigating to dashboard');
            this.router.navigate([Global.DefaultPage]);
          }
        }
      });
    } catch (error) {
      console.error('Error processing redirect:', error);
      this.router.navigate([Global.DefaultPage]);
    }
  }

  /**
   * Perform the actual redirect
   */
  private performRedirect(redirectUrl: string): void {
    try {
      // Decode the URL
      redirectUrl = decodeURIComponent(redirectUrl);

      // Validate the URL to prevent open redirect vulnerabilities
      if (this.isValidInternalUrl(redirectUrl)) {
        // Use setTimeout to ensure navigation stack is clear
        setTimeout(() => {
          this.router.navigate([redirectUrl]).catch(error => {
            console.error('Navigation error:', error);
            this.router.navigate([Global.DefaultPage]);
          });
        }, 100);
      } else {
        console.warn('Invalid redirect URL:', redirectUrl);
        this.router.navigate([Global.DefaultPage]);
      }
    } catch (error) {
      console.error('Error performing redirect:', error);
      this.router.navigate([Global.DefaultPage]);
    }
  }

  /**
   * Validate that URL is an internal route (security check)
   */
  private isValidInternalUrl(url: string): boolean {
    // Remove leading slashes and hash for comparison
    const cleanUrl = url.replace(/^[/#]+/, '');

    // List of valid internal routes
    const validRoutes = [
      'dashboard',
      'members',
      'employees',
      'attendance',
      'routines',
      'classes',
      'enquiry',
      'org-selector',
      'settings'
    ];

    // Check if URL starts with any valid route
    return validRoutes.some(route => cleanUrl.startsWith(route));
  }
}
